export default __webpack_public_path__ + "static/media/search-clear-icon.c1634b0c.svg";